import md5 from "md5";
import type { ComponentProps } from "react";

import { Avatar } from "@skilitics/designer-ui-components";

export interface UserAvatarProps extends ComponentProps<typeof Avatar> {
  email: string;
}

export const UserAvatar = ({ email, ...avatarProps }: UserAvatarProps) => {
  const formattedEmail = email.toLowerCase().trim();
  const gravatarUrl = `https://www.gravatar.com/avatar/${md5(formattedEmail)}?d=retro`;
  return <Avatar src={gravatarUrl} {...avatarProps} />;
};
